import { CMS } from '../utils/constants';

export enum Sentiment {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}

export enum CMSFeedbackTriggerType {
  POST_PURCHASE = 'post_purchase',
}

export interface UserFeedback {
  pluginInstallSource: CMS;
  siteUrl: string;
  cmsFeedbackTriggerType: CMSFeedbackTriggerType;
  sentiment?: Sentiment;
  feedbackComment?: string;
  wixPostPurchase?: boolean;
}
